import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export interface ErrorModalProps {
    errorMessage: string | undefined
    onHide: () => void
}

export function ErrorModalComponent({ errorMessage, onHide }: ErrorModalProps) {

    const [show, setShow] = React.useState<boolean>();

    React.useEffect(() => {
        setShow(errorMessage !== undefined && errorMessage.length > 0)
    }, [errorMessage]);

    const handleClose = function () {
        setShow(false);
        onHide();
    }

    return (
        <div>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon className="me-2" icon="exclamation-circle" />
                        Dealer Portal
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>An error occurred while performing your request:</div>
                    <span className="ms-2">{errorMessage}</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}